export default "__VITE_ASSET__3e741f92__"